import React, { useEffect, useState } from 'react'

function useWindowScale(imageWidth){
  const [scale, setScale] = useState(1)

  function setWindowScale(windowWidth){
    if (windowWidth < imageWidth){
      const newScale = windowWidth / (imageWidth + 80)
      setScale(newScale)
    }
  }

  function onResizeWindow(e){
    setWindowScale(e.target.innerWidth)
  }

  useEffect(() => {
    if (imageWidth){
      setWindowScale(window.innerWidth)
      window.addEventListener('resize', onResizeWindow)
    }

    return () => {
      window.removeEventListener('resize', onResizeWindow)
    }
  }, [imageWidth])

  return scale
}

export default useWindowScale
